// extracted by mini-css-extract-plugin
module.exports = {"heading":"ActivitiesList_heading__N4ete"};